<mat-dialog-content class="mat-typography">
  <section class="add-branch-dialog-wrapper">
    <h2 class="cmn-popup-title">
      {{ careerData 
          ? (careerForm.get('type')?.value === 'Warning' ? 'Edit Warning' : (careerForm.get('type')?.value === 'Promotion' ? 'Edit Promotion' : 'Edit Career'))
          : (careerForm.get('type')?.value === 'Warning' ? 'Add Warning' : (careerForm.get('type')?.value === 'Promotion' ? 'Add Promotion' : 'Add Career')) 
      }}
    </h2>
    
    <button class="cmn-close" mat-dialog-close></button>
    <form [formGroup]="careerForm" (ngSubmit)="onSubmit()">
      <div class="branch-form-wrapper full-width">
        <label class="radio-label">Career Type</label>
        <div class="type-selection">
          <label
            *ngFor="let type of employeeCareerTypes"
            class="radiobtn-wrapper"
          >
            <input
              type="radio"
              [value]="type.value"
              name="type"
              formControlName="type"
            />

            <span class="radiomark on-dialog"></span>
            {{ type.label }}
            <mat-error
              *ngIf="
                  careerForm.get('type')!.touched &&
                  careerForm.get('type')!.hasError('required')
                "
            >
              Item Type is required.
            </mat-error>
          </label>
        </div>
        <div
          class="form-wrapper"
          *ngIf="careerForm.get('type')?.value === 'Promotion'"
        >
          <label for="">Previous Designation<span class="red">*</span></label>
          <mat-form-field>
            <mat-select
              placeholder="Select Previous Designation"
              formControlName="previousPosition"
            >
              <mat-option
                *ngFor="let designation of designationData"
                [value]="designation.designationName"
              >
                {{ designation.designationName }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                      careerForm.get('previousPosition')!.touched &&
                      careerForm.get('previousPosition')!.hasError('required')
                  "
            >
              Previous Designation is required.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- <div
          class="form-wrapper"
          *ngIf="careerForm.get('type')?.value === 'Promotion'"
        >
          <label for="">Previous Designation</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter Previous Designation"
              formControlName="previousPosition"
            />
            <mat-error
              *ngIf="
                  careerForm.get('previousPosition')!.touched &&
                  careerForm.get('previousPosition')!.hasError('required')
                "
            >
              Previous Designation is required.
            </mat-error>
          </mat-form-field>
        </div> -->
        <div
          class="form-wrapper"
          *ngIf="careerForm.get('type')?.value === 'Promotion'"
        >
          <label for="">New Designation<span class="red">*</span></label>
          <mat-form-field>
            <mat-select
              placeholder="Select Designation"
              formControlName="currentPosition"
            >
              <mat-option
                *ngFor="let designation of designationData"
                [value]="designation.designationName"
              >
                {{ designation.designationName }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                careerForm.get('currentPosition')!.touched &&
                careerForm.get('currentPosition')!.hasError('required')
              "
              >New designation is required.</mat-error
            >
          </mat-form-field>
        </div>
        <!-- <div
          class="form-wrapper"
          *ngIf="careerForm.get('type')?.value === 'Promotion'"
        >
          <label for="">New Designation</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter New Designation"
              formControlName="currentPosition"
            />
            <mat-error
              *ngIf="
                  careerForm.get('currentPosition')!.touched &&
                  careerForm.get('currentPosition')!.hasError('required')
                "
            >
              New Designation is required.
            </mat-error>
          </mat-form-field>
        </div> -->
        <div
          class="form-wrapper"
          *ngIf="careerForm.get('type')?.value === 'Promotion' || careerForm.get('type')?.value === 'Warning' || careerForm.get('type')?.value === 'Grading'"
        >
          <label for="">Date<span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker14"
              placeholder="Select Date"
              formControlName="date"
              [matDatepickerFilter]="dateFilter"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker14"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker14></mat-datepicker
            ><mat-error
              *ngIf="
              careerForm.get('date')!.touched &&
              careerForm.get('date')!.hasError('required')
            "
              >Date is required.</mat-error
            >
          </mat-form-field>
        </div>
        <div
          class="form-wrapper"
          *ngIf="careerForm.get('type')?.value === 'Grading' || careerForm.get('type')?.value === 'Warning'"
        >
          <label for="">Reason<span class="red">*</span></label>
          <mat-form-field>
            <textarea
              matInput
              placeholder="Reason"
              formControlName="reason"
            ></textarea
            ><mat-error
              *ngIf="
            careerForm.get('reason')!.touched &&
            careerForm.get('reason')!.hasError('required')
          "
              >Reason is required.</mat-error
            >
          </mat-form-field>
        </div>

        <div
        class="form-wrapper"
        *ngIf="careerForm.get('type')?.value === 'Grading'"
      >
        <label for="">Rating<span class="red">*</span></label>
        <div class="score-bar">
          <ng-container *ngFor="let num of [1,2,3,4,5,6,7,8,9,10]">
            <div
              class="score-option"
              [class.selected]="careerForm.get('score')?.value === num.toString()"
              (click)="selectScore(num)"
            >
              {{ num }}
            </div>
          </ng-container>
        </div>
        <mat-error
          *ngIf="
            careerForm.get('score')!.touched &&
            careerForm.get('score')!.hasError('required')
          "
        >
          Rating is required.
        </mat-error>
      </div>
      </div>
      <div class="btn-wrapper">
        <button type="submit" class="cmn-popup-btn" [disabled]="loading">
          <span *ngIf="!loading">Submit</span>
          <span *ngIf="loading">Loading...</span>
        </button>
      </div>
    </form>
  </section>
</mat-dialog-content>
